var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notes",class:{card: _vm.isCard, 'primary-09': _vm.primary09}},[_c('h4',[_vm._t("headline")],2),_c('p',[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }